// extracted by mini-css-extract-plugin
export default {"list":"ColorBlock_list__t9xb9","item":"ColorBlock_item__SxUGy","isMultiColorItem":"ColorBlock_isMultiColorItem__iVeYI","isSelectedItem":"ColorBlock_isSelectedItem__tDFSb"};